import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MarketplaceParameter } from 'src/app/global/interfaces/marketplace-parameter';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CarroComprasProvider extends CarroComprasService {
  private cartConfig = environment.urlQueryParam;
  private retomaConfig = environment.retoma;
  private retoma = false;
  private codigoDescuento = null;

  private mostrarCarroSubject = new BehaviorSubject<boolean>(true);
  mostrarCarro$ = this.mostrarCarroSubject.asObservable();

  private retomaSubject = new BehaviorSubject<boolean>(false);
  retoma$ = this.retomaSubject.asObservable();

  private productsSubject = new BehaviorSubject<Array<Product>>([]);
  products$ = this.productsSubject.asObservable();

  private changeCantidadSubject = new BehaviorSubject<boolean>(false);
  changeCantidad$ = this.changeCantidadSubject.asObservable();

  private changeValorCantidadSubject = new BehaviorSubject<number>(0);
  changeValorCantidad$ = this.changeValorCantidadSubject.asObservable();

  private idRubroSubject = new BehaviorSubject<any>(null);
  idRubro$ = this.idRubroSubject.asObservable();

  private getPasoSubject = new BehaviorSubject<string>('');
  changePaso$ = this.getPasoSubject.asObservable();

  private aplicarDescuentoSubject = new BehaviorSubject<any>(null);
  aplicarDescuento$ = this.aplicarDescuentoSubject.asObservable()

  private removerDescuentoSubject = new BehaviorSubject<boolean>(false);
  removerDescuento$ = this.removerDescuentoSubject.asObservable()

  carroCompraVacio = false;
  private paso: string;

  constructor(private localStorageService: LocalStorageService) {
    super();
    this.retoma$.subscribe((value) => {

    });
  }

  protected set mostrarCarro(value: boolean) {
    this.mostrarCarroSubject.next(value);
  }

  protected get mostrarCarro(): boolean {
    return this.mostrarCarroSubject.value;
  }

  changeCantidad(cambio: boolean): void {
    this.changeCantidadSubject.next(cambio);
  }

  changeValorCantidad(data: number): void {
    if (this.products && this.products.length === 1) {
      this.products[0].cantidad = data.toString();
    }
    this.changeValorCantidadSubject.next(data);
  }

  get products(): Array<Product> {
    return this.productsSubject.value;
  }

  set products(products: Array<Product>) {
    this.productsSubject.next(products);
  }

  toogle(): void {
    this.mostrarCarro = !this.mostrarCarro;
  }

  show(): void {
    this.mostrarCarro = true;
  }

  hide(): void {
    this.mostrarCarro = false;
  }

  changeRetoma(value: boolean): void {
    this.retoma = value;
    this.retomaSubject.next(value);
  }

  getRetoma(): boolean {
    return this.retoma;
  }

  loadFromUrl(): MarketplaceParameter {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(this.cartConfig.productsParameterName)) {
      const trolley = atob(urlParams.get(this.cartConfig.productsParameterName));
      let marketplaceParameter: MarketplaceParameter = null;
      if (trolley) {
        try {
          const decoded = decodeURIComponent(escape(trolley));
          marketplaceParameter = JSON.parse(decoded) as MarketplaceParameter;
          this.products = marketplaceParameter.productos.map((marketProduct: Product) => {
            const product: Product = {
              isOpen: false,
              ...marketProduct
            };
            this.desplegarCarroByResolucion();
            this.changeRetoma(false);
            return product;
          });

          this.carroCompraVacio = true;
          this.changeRetoma(false);
          this.desplegarCarroByResolucion();
        } catch (exception) {
          console.error(urlParams, exception);
        }
      }
      return marketplaceParameter;
    /** TODO: Checar si aplica la eliminacion de este trozo dada la inexstencia de Retoma */  
    } else if (urlParams.has(this.retomaConfig.parameterName)) {
      const action = urlParams.get(this.retomaConfig.parameterName);
      if (action && action === 'retoma') {
        this.changeRetoma(true);
        this.hide();
      } else {
        this.changeRetoma(false);
        this.desplegarCarroByResolucion();
      }
      return null;
    }
   else {
      this.desplegarCarroByResolucion();
      this.changeRetoma(false);
      return null;
    }
  }

  private desplegarCarroByResolucion() {
    if (window.innerWidth < 1200) {
      this.hide();
    } else {
      this.show();
    }
  }

  getProductsEncoded(): string {
    if (!this.products || this.products.length === 0) {
      return null;
    }
    // return btoa(JSON.stringify(this.products[0]));
    return btoa(unescape(encodeURIComponent(JSON.stringify(this.products[0]))));
  }

  getCurrentProduct(): Product {
    let product = null;
    if (this.products && this.products.length === 1) {
      product = this.products[0];
    }
    return product;
  }

  removeProduct(product: Product): void {
    const index = this.products.findIndex((element) => element === product);
    if (index >= 0) {
      this.products.splice(index, 1);
    }
  }

  changePaso(paso: string) {
    this.getPasoSubject.next(paso);
  }

  aplicarDescuento(descuento: any) {
    this.codigoDescuento = descuento.codigo;
    this.aplicarDescuentoSubject.next(descuento);
  }

  getCodigoDescuento() {
    return this.codigoDescuento;
  }

  removerCodigoDescuento() {
    this.codigoDescuento = null;
    this.removerDescuentoSubject.next(true);
  }

}
